'use strict';

const czekanowskiSimilarity = require('../similarities/czekanowski');

module.exports = function czekanowskiDistance(a, b) {
    return 1 - czekanowskiSimilarity(a, b);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-distance/src/distances/czekanowski.js
 ** module id = 67
 ** module chunks = 0
 **/